import m from "../../geodata/es2015/greeceLow";
window.am4geodata_greeceLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/greeceLow.js
// module id = null
// module chunks = 